export default class GTMService{

    static TypeIn(){
        return {
            button: 'button',
            link: 'link'
        }
    }

    static dispatchInraction(lb,type,fluxo){
        let t = type || GTMService.TypeIn().button;
        window.dataLayer = window.dataLayer || [];
        let data = {
            'event':          'interaction',
            'event-category': 'b2c_ecare_next_biometry' + fluxo,
            'event-action':   'screen_click_'+t,
            'event-label':    lb,
            'event-value':    0
        };
        window.dataLayer.push(data);
    }

    static dispatchScreenView(fluxo,pageName){
        window.dataLayer = window.dataLayer || [];
        let screen_name = '/biometry-'+fluxo+pageName;

        let data = {
            'event':          'screenView',
            'screen-name':     `${screen_name}`,
            'event-category': null,
            'event-action':   null,
            'event-label':    null,
            'event-value':    0,
        };
        window.dataLayer.push(data);
    }

    static dispatchNoninteraction(lb,ac,fluxo){
        let c = ac || 'screen_view_none';
        window.dataLayer = window.dataLayer || [];
        let data = {
            'event':          'noninteraction',
            'event-category': 'b2c_ecare_next_biometry' + fluxo,
            'event-action':   c,
            'event-label':    lb,
            'event-value':    0,
        };
        window.dataLayer.push(data);
    }

}


// WEBPACK FOOTER //
// ./src/services/GTMService.js